import React from 'react'
import '../heroSection/hero.css'
import { Container, Row, Col, Image } from 'react-bootstrap'
import { Typewriter } from 'react-simple-typewriter'
import BrandExample from '../navBar/Brand'

function Intro() {
  return (
    <div className='hero'>
    <BrandExample />
    <Container fluid='md' id='introSection' className='introSection'>
        <Row className='introBlock'>
            <Col className='img-col' sm={12} lg='6'>
                <Container className='text-end img-container'>
                    <Image src="./assets/images/GauravInGreen.jpeg" className='gauravImg' height={'400'} width={'400'} />
                </Container>
            </Col>
            <Col className='intro-col'>
                <h1 className='heading text-start'>
                    Gaurav Bhardwaj
                </h1>
                <h3 className='text-start px-4'>
                    <span style={{color:'white'}}>
                    <Typewriter 
                        words={['A 3rd year Undergraduate Student Studying at IIT Kharagpur', 'A passionate Developer']}
                        loop = {true}
                        cursor = {true}
                        cursorColor='white'
                        cursorStyle = '_'
                    />
                    </span>
                </h3>
            </Col>
        </Row>
    </Container>
    </div>
  )
}

export default Intro